/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Download_BtnInputs */

const en_cad_download_btn = /** @type {(inputs: Cad_Download_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download`)
};

/**
* | output |
* | --- |
* | "Download" |
*
* @param {Cad_Download_BtnInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_download_btn = /** @type {((inputs?: Cad_Download_BtnInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Download_BtnInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_download_btn(inputs)
});
export { cad_download_btn as "cad.download.btn" }